module.exports = "//public.zight.com/packs/media/images/video-thumbnail-aed0aaa3169517e03c3363d4260a6d09.png";